<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="提现状态">
                        <el-select v-model="params.status" clearable>
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool2" style="justify-content:space-between;">
            <div>
                <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
                <span class="ps">PS：转账完成后请等待链上确认和数据同步 1~2 分钟。</span>
            </div>
            <div class="wallet">
                <div v-if="connected" class="connectOk">
                    <i/>
                    <p>
                        <span class="address">当前钱包地址：{{showAddress(walletAddress)}}</span>
                        <span class="address">USDT余额：{{myUsdtBalance}}</span>
                        <span class="address">ALB余额：{{myAldBalance}}</span>
                    </p>
                    <el-button type="primary" @click="openTransfer('USDT')">发起USDT转账</el-button>
                    <el-button type="primary" @click="openTransfer('ALD')">发起ALD转账</el-button>
                </div>
                <div v-else>
                    <el-button type="primary" @click="connectToMask()">链接钱包</el-button>
                </div>
            </div>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" highlight-current-row class="table-show-current" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" :selectable="selectFilter"></el-table-column>
            <el-table-column prop="id" align="center" label="提现ID" width="70"></el-table-column>
            <el-table-column prop="currency" align="center" label="币种" width="60"></el-table-column>
            <el-table-column align="center" label="提现地址" width="300" class-name="address">
                <template slot-scope="scope" v-if="scope.row.wayValue">
                    <span  v-clipboard:copy="scope.row.wayValue" v-clipboard:success="onCopy">
                        {{scope.row.wayValue}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            
            <el-table-column prop="amountTotal" label="提现总数" align="center"></el-table-column>
            <el-table-column prop="amountFee" label="手续费" align="center"></el-table-column>
            <el-table-column prop="amountFinal" label="实到" align="center"></el-table-column>
            <el-table-column label="提现状态" align="center" width="80">
                <template slot-scope="scope"><span :class="'status_'+scope.row.status">{{ statusMap[scope.row.status] }}</span></template>
            </el-table-column>
            <el-table-column label="申请时间" align="center" width="140">
                <template slot-scope="scope">{{ scope.row.createdAt }}</template>
            </el-table-column>
            <el-table-column label="链上hash" align="center" width="150" class-name="address">
                <template slot-scope="scope">
                    <a v-if="scope.row.txHash" target="_blank" :href="getChainScan()+'/tx/'+scope.row.txHash">{{showHash(scope.row.txHash)}}</a>
                </template>
            </el-table-column>
            <el-table-column label="完成时间" align="center" width="140">
                <template slot-scope="scope">{{ formatTimestamp(scope.row.txTime*1000) }}</template>
            </el-table-column>
            <!--
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope" v-if="scope.row.type != 'RECHARGE' && scope.row.status == 'PENDING'">
                    <el-button type="text" icon="el-icon-close"  @click="cancelOrder(scope.row)" size="mini" style="margin-left:10px;">取消</el-button>
                </template>
            </el-table-column>
            -->
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="转账详情" :visible.sync="dialogVisible" class="abow_dialog2" @close="dialogVisible = false" style="width: 500px;margin: auto;height: 300px;">
            <el-form label-width="150px" class="approveForm">
                <el-row>
                    <el-form-item label="订单数量">
                        <span>{{transferInfo.orderCount}} 个提现 {{transferInfo.selectCurrency}} 申请单</span>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="应转总数量">
                        <span>{{transferInfo.finalTotal}} {{transferInfo.selectCurrency}}</span>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmTransfer">确认转账</el-button>
                <el-button @click="dialogVisible = false">取消转账</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { assetsApi } from '@/api/api-assets';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
import Web3 from 'web3';
export default {
    data() {
        return {
            walletAddress:"",
            params: {
                status:"PENDING"
            },
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
            selectRow:[],
            dialogVisible:false,
            transferInfo:{},

            myUsdtBalance:0,
            myAldBalance:0,
            myBnbBalance:0,
            connected:false,
            web3Instance:null,
            usdtTokenContractInstance:null,
            aldTokenContractInstance:null,
            aldHomeContractInstance:null,
        };
    },
    created() {
        this.statusOptions = this.findDict("WITHDRAW_STATUS");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        this.handleSearch();

        let _this = this;
        if (window.ethereum) {
            window.ethereum.on('chainChanged', (_chainId) => {
                _this.connectWallet();
            });
            window.ethereum.on('accountsChanged', (_chainId) => {
                _this.connectWallet();
            });
        }
    },
    methods: {
        connectToMask(){
            let _this = this;
            this.connectWallet(function(address){
                _this.walletAddress = address;
                _this.web3Instance  = new Web3(window.ethereum);
                _this.usdtTokenContractInstance = new _this.web3Instance.eth.Contract(_this.UsdtToken_Contract.abi,_this.UsdtToken_Contract.address);
                _this.aldTokenContractInstance = new _this.web3Instance.eth.Contract(_this.AldToken_Contract.abi,_this.AldToken_Contract.address);
                _this.aldHomeContractInstance = new _this.web3Instance.eth.Contract(_this.AldHome_Contract.abi,_this.AldHome_Contract.address);
                _this.connected = true;
                _this.usdtTokenContractInstance.methods.balanceOf(_this.walletAddress).call().then((result) => {
                    _this.myUsdtBalance = _this.convertFromByUnit(result,6);
                });
                _this.aldTokenContractInstance.methods.balanceOf(_this.walletAddress).call().then((result) => {
                    _this.myAldBalance = _this.convertFromByUnit(result,6);
                });
                _this.$message.success({message: "链接钱包成功",duration: 1500});
            });
        },
        refreshWalletData(){
            this.usdtTokenContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myUsdtBalance = this.convertFromByUnit(result,6);
            });
            this.aldTokenContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myAldBalance = this.convertFromByUnit(result,6);
            });
        },
        selectFilter(row, index){
            if(row.status == "PENDING"){
                return true;
            }else{
                return false;
            }
        },
        handleSelectionChange(val){
            this.selectRow = val;
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            assetsApi.findWithdrawPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        openTransfer(selectCurrency){
            if(!this.selectRow || this.selectRow.length==0){
                this.$message.warning("请选择要处理的提现申请单");
                return;
            }
            let targetList = [];
            let amountList = [];
            let idList = [];
            let finalTotal = 0;
            let validResult = true;
            this.selectRow.forEach(v => {
                if(v.currency != selectCurrency){
                    validResult = false;
                    return;
                }
                let finalBigNumber = this.convertToBigNumberByUnit(v.amountFinal,6)
                targetList.push(v.wayValue)
                amountList.push(finalBigNumber);
                idList.push(v.id);
                finalTotal += v.amountFinal;
            })
            if(!validResult){
                this.$message.warning("请选择对应币种的提现申请单");
                return;
            }
            // 根据币种检查对应的余额
            if(selectCurrency === "USDT" && finalTotal > this.myUsdtBalance){
                this.$message.warning({message: "USDT余额不足",duration: 1500})
                return;
            }
            if(selectCurrency === "ALD" && finalTotal > this.myAldBalance){
                this.$message.warning({message: "ALD余额不足",duration: 1500})
                return;
            }
            this.transferInfo = {
                selectCurrency:selectCurrency,
                finalTotal:finalTotal,
                orderCount:this.selectRow.length,
                targetList:targetList,
                amountList:amountList,
                idList:idList,
            }
            this.dialogVisible = true;
        },
        async confirmTransfer(){
            let _this = this;
            if(!this.aldTokenContractInstance || !this.usdtTokenContractInstance || !this.aldHomeContractInstance || !this.walletAddress){
                return;
            }
            let tokenContractInstance = this.transferInfo.selectCurrency == "USDT"?this.usdtTokenContractInstance:this.aldTokenContractInstance;
            this.showConfirmBox(2,this.transferInfo.selectCurrency);
            let finalBigNumber = this.convertToBigNumberByUnit(this.transferInfo.finalTotal,6);
            let allowance = await tokenContractInstance.methods.allowance(this.walletAddress, this.AldHome_Contract.address).call();
            if(this.convertToNumberByUnit(this.transferInfo.finalTotal,6) > allowance){
                if(!await this.tokenApprove(tokenContractInstance,this.walletAddress,this.AldHome_Contract.address,finalBigNumber)){
                    this.$message.warning({message: "授权失败",duration: 1500});
                    return;
                }
            }
            this.setConfirmBox(2);
            this.contractSend(
                this.aldHomeContractInstance.methods.withdraw(
                    this.transferInfo.selectCurrency == "USDT"?1:2,
                    this.transferInfo.targetList,
                    this.transferInfo.amountList,
                    this.transferInfo.idList
                ),this.walletAddress,0).then((result)=>{
                _this.hideConfirmBox();
                if(result.status){
                    _this.dialogVisible = false;
                    _this.refreshWalletData();
                    _this.$message.success({message: "转账成功",duration: 3000});
                }else{
                    _this.$message.error({message: "转账失败",duration: 1500})
                }
            }).catch((error) => {
                _this.$message.error({message: "转账失败",duration: 1500})
            });
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['提现ID', '会员地址','提现币种',"提现总数","手续费","实到数量","提现状态","链上hash","申请时间","完成时间"];
            let columns = ['id', 'memberAddress', 'currency','amountTotal', 'amountFee', 'amountFinal','status', 'txHash',"createdAt","txTime"];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                if(c == 'txTime'){
                    return this.formatTimestamp(val*1000);
                }else if(c == 'status'){
                    return this.statusMap[val];
                }else{
                    return val;
                }   
            }));
            exportData2(header,data,"提现记录");
        },
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
    }
};
</script>
<style lang='less' scope>
span.status_CONFIRM{
    color:#ffffff;
    background-color: green;
    padding: 2px 10px;
    border-radius: 20px;
}
span.status_CANCEL{
    color:#aaaaaa;
    background-color: #dddddd;
    padding: 2px 10px;
    border-radius: 20px;
}
span.status_PENDING{
    background: #EEB426;
    color: #000000;
    padding: 2px 10px;
    border-radius: 20px;
}
.tableTool2{
    .wallet{
        display:flex;
        align-items:center;
        .connectOk{
            display:flex;
            align-items:center;
            justify-content: space-between;
            .address{
                color:rgb(64, 104, 252);
                margin-right:20px;
                font-size: 13px;
            }
            i{
                width:5px;
                height:5px;
                border-radius:5px;
                display:block;
                background-color:#80d6a1;
                margin-right:5px;
            }
        }
    }
}
</style>